// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__GIc7H","item":"styles_item__MtBm0","specialty":"styles_specialty__+plsw","trade":"styles_trade__8z-CQ"};